import { Page } from "../../Page"
import { useEffect } from 'react';
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setReloadButtonVisible } from '../menu/menuSlice'
import {  useAppDispatch } from '../../app/hooks';
import styles from './TandC.module.css'
import { BackButton } from "../menu/BackButton";
export function TermsAndConditions() {
	const dispatch = useAppDispatch()
	useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setReloadButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
      }, [dispatch]);
    return (
        <Page>
          <div className={styles.bannerContainer}>
              <div>
                  <h2>PartyPlanner.</h2>
                     <h4>Organise, invite and celebrate in style.</h4>
              </div>
              <div className={styles.bannerButton}>
                  <BackButton/>
              </div>
          </div>
          <div className={styles.content}>
            <h1>Terms and Conditions</h1>
            <p>These terms and conditions (the "Terms and Conditions") govern the use of partyplanner.abs.uk.com (the "Site"). This Site is owned and operated by Adaptive Business Solutions Limited. This Site is a event organisation.</p>
            <p>By using this Site, you indicate that you have read and understand these Terms and Conditions and agree to abide by them at all times.</p>
            <h2> Intellectual Property</h2>
            <p>All content published and made available on our Site is the property of Adaptive Business Solutions Limited and the Site's creators. This includes, but is not limited to images, text, logos, documents, downloadable files and anything that contributes to the composition of our Site.</p>
            <h2>Acceptable Use</h2>
            <p>As a user of our Site, you agree to use our Site legally, not to use our Site for illegal purposes, and not to:</p>
            <div>
		<li  value="1"><span>Harass or mistreat other users of our Site;</span>
		</li>
		<li  value="2"><span>Violate the rights of other users of our Site;</span>
		</li>
		<li  value="3"><span>Violate the intellectual property rights of the Site owners or any third party to the Site;</span>
		</li>
		<li  value="4"><span>Hack into the account of another user of the Site;</span>
		</li>
		<li  value="5"><span>Act in any way that could be considered fraudulent; or</span>
		</li>
		<li  value="6"><span>Post any material that may be deemed inappropriate or offensive.</span>
		</li>
	</div>
    <p> If we believe you are using our Site illegally or in a manner that violates these Terms and Conditions, we reserve the right to limit, suspend or terminate your access to our Site. We also reserve the right to take any legal steps necessary to prevent you from accessing our Site.</p>
    <h2> User Contributions</h2>
    <p>Users may post the following information on our Site:</p>
    <div>
    <li value='1'>Add events, tasks and attendees.. </li>
    </div>
    <p>By posting publicly on our Site, you agree not to act illegally or violate these Terms and Conditions.</p>
    <h2>Accounts</h2>
    <p>When you create an account on our Site, you agree to the following:</p>
    <div>
		<li  value="1"><span>You are solely responsible for your account and the security and privacy of your account, including passwords or sensitive information attached to that account; and</span>
		</li>
		<li  value="2"><span>All personal information you provide to us through your account is up to date, accurate, and truthful and that you will update your personal information if it changes.</span>
		</li>
	</div>
    <p> We reserve the right to suspend or terminate your account if you are using our Site illegally or if you violate these Terms and Conditions.</p>
        <h2> User Goods and Services </h2>
        <p>Site allows users to sell goods and services. We do not assume any responsibility for the goods and services users sell on our Site. We cannot guarantee the quality or accuracy of any goods and services sold by users on our Site. However, if we are made aware that a user is violating these Terms and Conditions, we reserve the right to suspend or prohibit the user from selling goods and services on our Site.</p>
        <h2> Links to Other Websites </h2>
        <p> Our Site contains links to third party websites or services that we do not own or control. We are not responsible for the content, policies, or practices of any third party website or service linked to on our Site. It is your responsibility to read the terms and conditions and privacy policies of these third party websites before using these sites.</p>
        <h2> Limitation of Liability</h2>
        <p> Adaptive Business Solutions Limited and our directors, officers, agents, employees, subsidiaries, and affiliates will not be liable for any actions, claims, losses, damages, liabilities and expenses including legal fees from your use of the Site.</p>
        <h2> Indemnity</h2>
        <p> Except where prohibited by law, by using this Site you indemnify and hold harmless Adaptive Business Solutions Limited and our directors, officers, agents, employees, subsidiaries, and affiliates from any actions, claims, losses, damages, liabilities and expenses including legal fees arising out of your use of our Site or your violation of these Terms and Conditions.</p>
        <h2> Applicable Law</h2>
        <p> These Terms and Conditions are governed by the laws of the Country of England.</p>
        <h2> Severability</h2>
        <p>If at any time any of the provisions set forth in these Terms and Conditions are found to be inconsistent or invalid under applicable laws, those provisions will be deemed void and will be removed from these Terms and Conditions. All other provisions will not be affected by the removal and the rest of these Terms and Conditions will still be considered valid.</p>
        <h2> Changes</h2>
        <p> These Terms and Conditions may be amended from time to time in order to maintain compliance with the law and to reflect any changes to the way we operate our Site and the way we expect users to behave on our Site. We will notify users by email of changes to these Terms and Conditions or post a notice on our Site.</p>
        <h2> Contact Details</h2>
        <p>Please contact us if you have any questions or concerns. Our contact details are as follows:</p><p>02476 939914</p>customer-services@abs.uk.com<p>Unit 6, Centenary Business Centre, Nuneaton, CV11 6RY
        </p> 
        </div>
        </Page>
    )}